import React, { useState, useEffect } from 'react';
import './Game2.css';
import whirlpoolVideo from './whirlpool.mp4'; // 引入影片文件

const questions = [
  {
    question: "小櫻遇到了誰？",
    options: ["可可與豆豆", "龜仙人"],
    answer: "可可與豆豆"
  },
  {
    question: "小櫻生活在什麼地方？",
    options: ["溪邊", "海邊"],
    answer: "溪邊"
  },
  {
    question: "小櫻身上有什麼特別的記號？",
    options: ["橢圓形斑點", "圓形斑點"],
    answer: "橢圓形斑點"
  },
  {
    question: "小櫻收到什麼禮物？",
    options: ["巧克力", "蛋糕"],
    answer: "巧克力"
  },
  {
    question: "小櫻為什麼會收到禮物？",
    options: ["他是巧克力國王的好朋友", "牠以前送過巧克力國王禮物"],
    answer: "他是巧克力國王的好朋友"
  },
  {
    question: "小櫻、可可與豆豆遇到了什麼危險？",
    options: ["掉進漩渦", "被海浪捲走"],
    answer: "掉進漩渦"
  },
  {
    question: "水域繪本有幾種動物？",
    options: ["4", "8種"],
    answer: "4種"
  },
  {
    question: "黑皮的完整名字是？",
    options: ["黑面琵鷺", "臺灣黑熊"],
    answer: "黑面琵鷺"
  },
  {
    question: "黑皮生活在什麼地方？",
    options: ["濕地", "海邊"],
    answer: "濕地"
  },
  {
    question: "可可與豆豆幫了皮什麼忙？",
    options: ["收拾垃圾", "找一個新家"],
    answer: "收拾垃圾"
  }
];

const shuffleOptions = (questions) => {
  return questions.map(question => {
    const shuffledOptions = question.options.sort(() => Math.random() - 0.5);
    return { ...question, options: shuffledOptions };
  });
};

const Game2 = () => {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [score, setScore] = useState(0);
  const [shuffledQuestions, setShuffledQuestions] = useState([]);

  useEffect(() => {
    setShuffledQuestions(shuffleOptions(questions));
  }, []);

  const handleAnswerOptionClick = (isCorrect) => {
    if (isCorrect) {
      setScore(score + 1);
      const nextQuestion = currentQuestion + 1;
      if (nextQuestion < shuffledQuestions.length) {
        setCurrentQuestion(nextQuestion);
      } else {
        alert(`遊戲結束！你的得分是 ${score + 1} 分`);
        setCurrentQuestion(0);
        setScore(0);
      }
    } else {
      alert(`答錯了！遊戲重新開始。`);
      handleWrongAnswer();
      setCurrentQuestion(0);
      setScore(0);
    }
  };

  function handleWrongAnswer() {
    playFullScreenVideo(whirlpoolVideo, `${process.env.PUBLIC_URL}/assets/p1.png`, `${process.env.PUBLIC_URL}/assets/p2.png`);
  }

  function playFullScreenVideo(videoSrc, imageSrc1, imageSrc2) {
    const videoElement = document.createElement('video');
    videoElement.src = videoSrc;
    videoElement.style.position = 'fixed';
    videoElement.style.top = '0';
    videoElement.style.left = '0';
    videoElement.style.width = '100%';
    videoElement.style.height = '100%';
    videoElement.style.zIndex = '1000';
    videoElement.autoplay = true;
    videoElement.muted = true; // 添加這行
    videoElement.onloadstart = () => {

        imageElement1.classList.add('fade-out'); // 添加渐隐类
        imageElement2.classList.add('fade-out'); // 添加渐隐类
        setTimeout(() => {
          document.body.removeChild(imageElement1); // 移除图片1
          document.body.removeChild(imageElement2); // 移除图片2
        }, 1000); // 等待动画结束后移除，时间延长到10秒
    };
    videoElement.onended = () => {
        document.body.removeChild(videoElement);
 
    };

    document.body.appendChild(videoElement);
    console.log('Video element added to DOM:', videoElement); // 添加日誌

    // 添加图片元素1
    const imageElement1 = document.createElement('img');
    imageElement1.src = imageSrc1; // 使用传入的图片路径
    imageElement1.style.position = 'fixed';
    imageElement1.style.top = '50%';
    imageElement1.style.left = '40%';
    imageElement1.style.transform = 'translate(-50%, -50%)';
    imageElement1.style.zIndex = '1001'; // 确保图片在视频上方
    document.body.appendChild(imageElement1);
    console.log('Image element 1 added to DOM:', imageElement1); // 添加日誌

    // 添加图片元素2
    const imageElement2 = document.createElement('img');
    imageElement2.src = imageSrc2; // 使用传入的图片路径
    imageElement2.style.position = 'fixed';
    imageElement2.style.top = '50%';
    imageElement2.style.left = '60%';
    imageElement2.style.transform = 'translate(-50%, -50%)';
    imageElement2.style.zIndex = '1001'; // 确保图片在视频上方
    document.body.appendChild(imageElement2);
    console.log('Image element 2 added to DOM:', imageElement2); // 添加日誌
  }

  return (
    <div className="container">
      <h1>這是遊戲二頁面</h1>
      <img
        src={`${process.env.PUBLIC_URL}/assets/background.png`}
        alt="background"
        className="background-image"
      />
      <div className="question-section">
        <h2>第 {currentQuestion + 1} 題: {shuffledQuestions[currentQuestion]?.question}</h2>
        <div className="answer-section">
          {shuffledQuestions[currentQuestion]?.options.map((option) => (
            <button
              key={option}
              onClick={() => handleAnswerOptionClick(option === shuffledQuestions[currentQuestion].answer)}
            >
              {option}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Game2;